import React from "react";
import { ServerComponentCaller } from "../../helpers";

const TipsCiclos = (props) => (
  <ServerComponentCaller url={"assets/data/pages/tips/tipsCiclos.json"} />
);

export default TipsCiclos;
